<template>
  <div class="row" v-if="isAjout">
              <!-- Modern Icons Wizard -->
              <div class="col-12 mb-4">
                <div class="bs-stepper wizard-icons wizard-icons-example mt-2">
                    
                 <div style="padding: 10px; text-align: end;">
                  <button @click="closeAjout()" type="button" class="btn btn-danger waves-effect waves-light">Annuler</button>
                 </div>
                      
                  <div class="bs-stepper-header">
                    <div :class="{'step' : true, 'active' : step_one}" data-target="#account-details-modern">
                      <button type="button" class="step-trigger" aria-selected="true">
                        <span class="bs-stepper-label">Etape 1</span>
                      </button>
                    </div>
                    <div class="line">
                      <i class="mdi mdi-chevron-right"></i>
                    </div>
                    <div :class="{'step' : true, 'active' : step_two}" data-target="#personal-info-modern">
                      <button type="button" class="step-trigger" aria-selected="false">
                        <span class="bs-stepper-label">Etape 2</span>
                      </button>
                    </div>

                    
                  </div>
                  <div class="bs-stepper-content">
                    <form @submit="addProspect($event)">
                      <!-- Account Details -->
                      <div id="account-details-modern" :class="{'content' : true, 'active': step_one, 'dstepper-block' : step_one}">
                        <div class="row g-4 mb-4 align-items-center">
                          <div class="col-4">
                              <div class="form-floating form-floating-outline">
                                   <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.id_admin">
                                      <option v-for="admin in admins" :value="admin.id">{{ admin.nom }} {{ admin.prenoms}}</option>
                                   </select>
                                   <label for="selectpickerBasic">Gestionnaire</label>
                               </div>
                          </div>
                          <div class="col-sm-4">
                            <div class="form-floating form-floating-outline">
                              <input type="text" id="username-modern" class="form-control" placeholder="Nom de la société" v-model="prospect.suivi_par">
                              <label for="username-modern">Suivi Par</label>
                            </div>
                          </div>
                        </div>
                        <div class="row g-4">
                          <div class="col-sm-4">
                            <div class="form-floating form-floating-outline">
                              <input type="text" id="username-modern" class="form-control" placeholder="Nom de la société" v-model="prospect.nom_societe">
                              <label for="username-modern">Nom de la société</label>
                            </div>
                          </div>
                          <div class="col-sm-4">
                              <div class="form-floating form-floating-outline">
                                   <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.id_sector">
                                    <option v-for="secteur in secteurs" :value="secteur.id">{{ secteur.libelle_sector }}</option>
                                   </select>
                                   <label for="selectpickerBasic">Secteur d'activité</label>
                               </div>
                          </div>
                          <div class="col-sm-4">
                              <div class="form-floating form-floating-outline">
                              <input type="text" id="username-modern" class="form-control" placeholder="Effectif" v-model="prospect.effectif">
                              <label for="username-modern">Effectif</label>
                            </div>
                          </div>

                         <div class="row g-4">
                          <div class="col-sm-3">
                              <div class="form-floating form-floating-outline">
                              <input type="text" id="username-modern" class="form-control" placeholder="DG" v-model="prospect.dg">
                              <label for="username-modern">DG</label>
                            </div>
                          </div>
                          <div class="col-sm-3">
                              <div class="form-floating form-floating-outline">
                              <input type="text" id="username-modern" class="form-control" placeholder="DRH" v-model="prospect.drh">
                              <label for="username-modern">DRH</label>
                            </div>
                          </div>
                          <div class="col-sm-3">
                              <div class="form-floating form-floating-outline">
                              <input type="text" id="username-modern" class="form-control" placeholder="Interlocuteur" v-model="prospect.interlocuteur">
                              <label for="username-modern">Interlocuteur</label>
                            </div>
                          </div>
                          <div class="col-sm-3">
                              <div class="form-floating form-floating-outline">
                              <input type="text" id="username-modern" class="form-control" placeholder="Fonction" v-model="prospect.fonction">
                              <label for="username-modern">Fonction</label>
                            </div>
                          </div>
                          
                         </div>
                         <div class="row g-4 align-items-center">
                          <div class="col-sm-3">
                              <div class="form-floating form-floating-outline">
                              <input type="text" id="username-modern" class="form-control" placeholder="Contact" maxlength="10" v-model="prospect.contact_societe">
                              <label for="username-modern">Contact société</label>
                            </div>
                          </div>
                            <div class="col-sm-3">
                                  <Calendar dateFormat="dd/mm/yy" placeholder="Date 1er contact" v-model="prospect.date_premier_contact"  showIcon style="width: 100%;"/>
                              </div>
                              <div class="col-sm-3">
                                  <Calendar dateFormat="dd/mm/yy" placeholder="Dernier contact" v-model="prospect.dernier_contact"  showIcon style="width: 100%;"/>
                              </div>
                          <div class="col-3">
                              <div class="form-floating form-floating-outline">
                                   <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.id_nature_prospection">
                                    <option v-for="prospection in prospections" :value="prospection.id">{{ prospection.libelle_nature_prospection }}</option>
                                   </select>
                                   <label for="selectpickerBasic">Nature prospection</label>
                               </div>
                          </div>
                          
                         </div>
                         <hr >
                         <div class="row">
                            <div class="col-md-12 p-4">
                                <small class="fw-semibold d-block">Retour prospect</small>
                                <div class="form-check form-check-inline mt-3">
                                  <input class="form-check-input" v-model="prospect.interesse" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="oui">
                                  <label class="form-check-label" for="inlineRadio1">Interessé</label>  
                                </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" v-model="prospect.interesse" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="non">
                                <label class="form-check-label"  for="inlineRadio2">Pas interssé</label>
                              </div>
                          </div>
                          
                          <div class="col-md-12 p-4">
                                <small class="fw-semibold d-block">Suite à donner</small>
                                <div class="form-check form-check-inline mt-3">
                                  <input class="form-check-input" v-model="prospect.suite" type="radio"  id="inlineRadio3" value="rencontre">
                                  <label class="form-check-label" for="inlineRadio3">Rencontre</label>  
                                </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" v-model="prospect.suite" type="radio"  id="inlineRadio4" value="proposition">
                                <label class="form-check-label"  for="inlineRadio4">Proposition</label>
                              </div>
                          </div>
                         </div>
                          <div class="col-12 d-flex justify-content-between">
                            <button class="btn btn-outline-secondary btn-prev waves-effect" disabled="">
                              <i class="mdi mdi-arrow-left me-sm-1"></i>
                              <span class="align-middle d-sm-inline-block d-none">Précédent</span>
                            </button>
                            <div class="d-flex">
                              <button type="submit" class="btn btn-primary btn-next waves-effect waves-light" :disabled="toNext">
                                  <span class="align-middle d-sm-inline-block d-none me-sm-1">Enregistrer</span>
                              </button>
                              <!-- :disabled="prospect.interesse!='oui'&&toNext" -->
                              <button type="button" class="btn btn-label-dark waves-effect ml-2" :disabled="test"  @click="goStepTwo()">
                                  <span class="align-middle d-sm-inline-block d-none me-sm-1">Suivant</span>
                                  <i class="mdi mdi-arrow-right"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Personal Info -->
                      <div id="personal-info-modern" :class="{'content' : true, 'active': step_two, 'dstepper-block' : step_two}">
                        <div class="row g-4">
                          <div class="col-sm-4">
                              <div class="form-floating form-floating-outline">
                                   <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.id_garanties">
                                      <option v-for="garantie in garanties" :value="garantie.id">{{ garantie.libelle_garantie}}</option>
                                   </select>
                                   <label for="selectpickerBasic">Garantie à proposer</label>
                              </div>
                          </div>
                          <div class="col-sm-4">
                              <div class="form-floating form-floating-outline">
                                   <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.type_contrat">
                                      <option value="groupe-ouvert">Groupe ouvert</option>
                                      <option value="groupe-ferme">Groupe fermé</option>
                                   </select>
                                   <label for="selectpickerBasic">Type contrat retenu</label>
                              </div>
                          </div>
                          <div class="col-sm-4">
                              <div class="form-floating form-floating-outline">
                                   <select  class="form-select form-select-lg" data-style="btn-default"  v-model="prospect.liste_cotation">
                                      <option value="standard">Standard</option>
                                      <option value="Personnaliser">Personnaliser</option>
                                   </select>
                                   <label for="selectpickerBasic">Cotation</label>
                              </div>
                          </div>
                          <div class="row g-4">
                            <div class="col-sm-4">
                              <div class="form-floating form-floating-outline">
                              <input type="text" id="username-modern" class="form-control" placeholder="CA" v-model="prospect.prevision_annuelle">
                              <label for="username-modern">CA attendu</label>
                            </div>
                          </div>
                          <div class="col-sm-4">
                              <div class="form-floating form-floating-outline">
                                   <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.date_prevision_annuelle">
                                      <option value="T1">T1</option>
                                      <option value="T2">T2</option>
                                      <option value="T3">T3</option>
                                      <option value="T3">T4</option>
                                   </select>
                                   <label for="selectpickerBasic">Date prévisionnelle conclusion</label>
                              </div>
                          </div>
                          <div class="col-sm-4">
                              <div class="form-floating form-floating-outline">
                                   <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.projet_convention">
                                      <option value="oui">Oui</option>
                                      <option value="non">Non</option>
                                   </select>
                                   <label for="selectpickerBasic">Projet convention</label>
                              </div>
                          </div>
                          </div>
                          <div class="row g-4">
                              <div class="col-sm-6">
                                <div class="form-floating form-floating-outline">
                                    <select  class="form-select form-select-lg" data-style="btn-default"  v-model="prospect.offre_commerciale">
                                        <option value="oui">Oui</option>
                                        <option value="non">Non</option>
                                    </select>
                                    <label for="selectpickerBasic">Offre commerciale</label>
                                </div>
                            </div>
                          <div class="col-sm-6" v-if="prospect.offre_commerciale==='oui'">
                              <div class="form-floating form-floating-outline">
                                   <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.type_offre">
                                      <option value="oui">Personnalisée</option>
                                      <option value="non">Standard</option>
                                   </select>
                                   <label for="selectpickerBasic">Type offre</label>
                              </div>
                          </div>
                          <div class="col-sm-12">
                                <label for="selectpickerBasic">Observation</label>
                                <textarea v-model="prospect.observations"  class="form-control" placeholder="Observation" aria-label="Observation" aria-describedby="basic-icon-default-message2"></textarea>
                              </div>
                          </div>
                          <div class="col-12 d-flex justify-content-between">
                            <button type="button" class="btn btn-outline-secondary btn-prev waves-effect" @click="prevStepOne()">
                              <i class="mdi mdi-arrow-left me-sm-1"></i>
                              <span class="align-middle d-sm-inline-block d-none">Précédent</span>
                            </button>
                            <div class="d-flex">
                              <button type="submit" class="btn btn-primary btn-next waves-effect waves-light">
                                  <span class="align-middle d-sm-inline-block d-none me-sm-1">Enregistrer</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Address -->
                     
                    </form>
                  </div>
                </div>
              </div>
              
            </div>
</template>

<script>
  import Calendar from 'primevue/calendar';
  // import { menu } from "@/assets/js/menu.js"; 
  // import { helpers } from "@/assets/js/helpers.js"; 
  // import { main } from "@/assets/js/main.js"; 
  import "vue-toastification/dist/index.css";
  import { useToast } from "vue-toastification";
  const toast = useToast();

  export default {
      name: 'AjoutProspect',
      components : {
          Calendar
      },
      props: {
          isAjout : Boolean,
          admins : Array,
          garanties : Array,
          secteurs : Array,
          prospections : Array
      },
      data() {
          return {
              step_one : true,
              step_two : false,
              step_three : false,
              prospect : {
                  id_admin : '',
                  nom_societe : '',
                  effectif : '',
                  dg : '',
                  interlocuteur : '',
                  contact_societe : '',
                  date_premier_contact : '',
                  id_nature_prospection : '',
                  interesse : '',
                  id_garanties : '',
                  type_contrat : '',
                  liste_cotation : '',
                  offre_commerciale : '',
                  prevision_annuelle : '',
                  projet_convention : '',
                  validation_projet : '',
                  signature : '',
                  date : '',
                  souscription : '',
                  reglements : '',
                  observations : '',
                  dernier_contact : '',
                  drh : '',
                  fonction : '',
                  suivi_par : '',
                  type_offre : '',
                  date_prevision_annuelle : '',
                  suite : '',
                  id_sector : '',
              }
          }
      },
      mounted(){
          
      },
      computed : {
            toNext(){
             return this.prospect.id_admin === '' || this.prospect.nom_societe === '' || 
             this.prospect.date_premier_contact === '' || this.prospect.id_sector === '' || this.prospect.effectif === '' ||
             this.prospect.dg === '' || this.prospect.drh === '' || this.prospect.interlocuteur === '' || 
             this.prospect.contact_societe === '' || this.prospect.id_nature_prospection === '' || this.prospect.interesse === ''
            },
            test(){
              return (this.toNext||this.prospect.interesse !='oui')
            }
        },
      methods : {
          closeAjout(){
              this.$emit('closeAjout')
          },
          async addProspect(e){
              e.preventDefault()
              const datas = new FormData()
                  
                  for(const objet in this.prospect){
                    datas.append(objet, this.prospect[objet])
                  }
                  datas.set('date_premier_contact', new Date(this.prospect.date_premier_contact).toLocaleDateString())
                  datas.set('dernier_contact', new Date(this.prospect.dernier_contact).toLocaleDateString())

                  let response = await this.$axios.post('prospect/add', datas);
                    if(response.data.code ===400){
                        toast.error(response.data.message)
                        return
                    }
                    
                    toast.success(response.data.message)
                  
                  this.resetDatas()
                this.$emit('AjoutProspect')
          },
          goStepTwo(){
              this.step_one = false
              this.step_two = true
          },
          prevStepOne(){
              this.step_one = true
              this.step_two = false
          },
          resetDatas(){
            for(const objet in this.prospect){
                    this.prospect[objet] = ''
            }
            this.step_one = true
            this.step_two = false
          }
      },
      beforeMount(){
          
      }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-danger{
  /* float: right !important; */
  /* margin-bottom: 20px; */
}
.light-style .bs-stepper.wizard-modern {
  background-color: transparent;
}
</style>
